







































































































import { ConfrontoDatiAnimaClient, EntitySelectItem } from "@/api/open-api";
import moment from "moment";
import Vue from "vue";

interface Data {
  dateFrom: string;
  dateTo: string;
  email: string;
  organizzazioni: EntitySelectItem[];
  confrontoDatianima: ConfrontoDatiAnimaClient;
  filters: {
    ougs: {
      selected: EntitySelectItem | null;
      total: EntitySelectItem[];
      filtered: EntitySelectItem[];
    };
  };
}

export default Vue.extend({
  data(): Data {
    const data = {
      email: "",
      dateFrom: "",
      dateTo: "",
      organizzazioni: Array<EntitySelectItem>(),
      confrontoDatianima: new ConfrontoDatiAnimaClient(undefined, {
        fetch: function (input: RequestInfo, init?: RequestInit) {
          if (!init) {
            init = { headers: new Headers() };
          }
          if (!init.headers) {
            init.headers = new Headers();
          }

          (init.headers as any).Authorization =
            Vue.prototype.$persistency.getItem("accessToken");

          return fetch(input, init);
        },
      }),
      filters: {
        ougs: {
          selected: null,
          total: [],
          filtered: [],
          onFilter(val: string, update: Function) {
            const needle = val.toLowerCase();
            data.filters.ougs.filtered = data.filters.ougs.total.filter(
              (x) => (x.description ?? "").toLowerCase().indexOf(needle) > -1
            );
            update();
          },
        },
      },
    } as Data;

    return data;
  },

  mounted() {
    this.getOrganizations();
  },

  methods: {
    validateEmail(email) {
      const regularExpression =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regularExpression.test(String(email).toLowerCase());
    },

    //prendo le organizzazioni per la select
    async getOrganizations() {
      this.filters.ougs.total = await this.confrontoDatianima.getOugs();
      const userData = JSON.parse(localStorage.getItem("userData") ?? "{}");
      this.email = userData.email;
    },

    async getCompareFile() {
      if (this.filters.ougs.selected != null) {
        this.$q.loading.show();
        try {
          if (
            !this.validateEmail(this.email) &&
            this.email != "" &&
            this.email != null
          ) {
            this.$q.notify({
              progress: true,
              message: `inserire una mail valida`,
              type: "negative",
            });
            this.$q.loading.hide();
            return;
          }

          var result = await this.confrontoDatianima.getComparedFile(
            moment(this.dateFrom),
            moment(this.dateTo),
            this.filters.ougs.selected?.id,
            this.email
          );
          if (result.message != null) {
            this.$q.notify({
              progress: true,
              message: `${result.message}`,
              type: "positive",
            });
            this.$q.loading.hide();
          } else {
            this.$q.notify({
              progress: true,
              message: `${result.error}`,
              type: "negative",
            });
            this.$q.loading.hide();
          }
        } catch (err) {
          this.$q.notify({
            progress: true,
            message: `${err}`,
            type: "negative",
          });
          this.$q.loading.hide();
        }
        this.$q.loading.hide();
      } else {
        this.$q.notify({
          progress: true,
          message: "L'organizzazione è obbligatoria",
          type: "negative",
        });
        this.$q.loading.hide();
      }
    },
  },
});
